export const hasArrayChanged = (a: any[] = [], b: any[] = []) => {
  return a.length !== b.length || a.some((item, index) => !Object.is(item, b[index]));
};
